// Vendor
import {InMemoryCache, NormalizedCache} from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import {BatchHttpLink} from 'apollo-link-batch-http';

import {createAbsintheHttpBatchingParserMiddleware} from './middlewares/absinthe-http-batching-parser';
import {createAbsintheUploadMiddleware} from './middlewares/absinthe-upload';
import {createAuthMiddleware} from './middlewares/authorization';

// Config
import {API_URL, GRAPHQL_ENDPOINT} from 'isee/config/environment';

// Services
import ReduxService from 'isee/services/redux/redux';

// Constants
const URI = `${API_URL}/${GRAPHQL_ENDPOINT}`;

export class ApolloService {
  private _client: ApolloClient<NormalizedCache>;

  public get client(): ApolloClient<NormalizedCache> {
    return this._client;
  }

  constructor(reduxService: typeof ReduxService) {
    const authMiddleware = createAuthMiddleware(reduxService.store);
    const uploadMiddleware = createAbsintheUploadMiddleware({uri: URI});
    const absintheHttpBatchingParser = createAbsintheHttpBatchingParserMiddleware();
    const batchLink: any = new BatchHttpLink({uri: URI});

    const link = authMiddleware
      .concat(uploadMiddleware)
      .concat(absintheHttpBatchingParser)
      .concat(batchLink);

    const cache = new InMemoryCache();
    this._client = new ApolloClient({link, cache});
  }
}

export default new ApolloService(ReduxService);



// WEBPACK FOOTER //
// ./src/services/apollo/apollo.ts